// extracted by mini-css-extract-plugin
export default {"main":"NotebookLayout_main__yiooC","notebook-toggle":"NotebookLayout_notebook-toggle__Vc0lk"};